import { queryBot2 } from 'boot/axios';

export async function loadAuthorsByPortfolioId (portfolioId) {
    return queryBot2('loadAuthorsByPortfolioId', { portfolioId }).then((r) => {
        let authors;
        const result = r.data;
        if (result && typeof result === 'object') {
            authors = {};
            Object.values(result).forEach(i => {
                authors[i.project_id] = i;
            });
        }
        return authors;
    });
}

export async function loadAuthorByProjectId (projectId) {
    return queryBot2('loadAuthorByProjectId', { projectId }).then((r) => {
        let author;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            author = result;
        }
        return author;
    });
}

export async function loadUsersByProjectId (projectId) {
    return queryBot2('loadUsersByProjectId', { projectId }).then((r) => {
        let users;
        const result = r.data;
        if (result && typeof result === 'object') {
            users = result;
        }
        return users;
    });
}

export async function loadUserById (userId) {
    return queryBot2('loadUserById', { userId }).then((r) => {
        let user;
        console.log('sql:', r.data);
        const [result] = r.data;
        if (result && typeof result === 'object') {
            user = result;
        }
        return user;
    });
}

export async function loadUserInfoById (userId) {
    return queryBot2('loadUserInfoById', { userId }).then((r) => {
        let user;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            user = result;
        }
        return user;
    });
}

export async function loadUserCourses (userId) {
    return queryBot2('loadUserCourses', { userId }).then((r) => {
        let courses;
        const [result] = r.data;
        if (result && typeof result === 'object') {
            courses = result;
        }
        return courses;
    });
}

export async function loadUsersByProjectRoleId (projectId, role) {
    return queryBot2('loadUsersByProjectRoleId', { projectId, role }).then((r) => {
        let users;
        const result = r.data;
        if (result && typeof result === 'object') {
            users = result;
        }
        return users;
    });
}

export async function loadUsersByPortfolioCourseId (portfolioId, courseId) {
    const portfolio = await queryBot2('loadUsersByPortfolioCourseId1', { portfolioId }).then(async (r) => {
        const [result] = r.data;
        if (result && typeof result === 'object') {
            return result;
        }
        return undefined;
    });
    if (!portfolio || typeof portfolio !== 'object' || !portfolio.flows_id) {
        return undefined;
    }
    const flowsId = portfolio.flows_id.replace('[', '(').replace(']', ')').replaceAll('"', '').replaceAll(' ', '');
    return queryBot2('loadUsersByPortfolioCourseId2', { courseId, flowsId }).then((r) => {
        const result = r.data;
        // console.log('result >', result);
        return result && typeof result === 'object' ? result : undefined;
    });
}

export default loadAuthorByProjectId;
